// extracted by mini-css-extract-plugin
export default {"progress":"Progress_progress__0e+WW","progress_label":"Progress_progress_label__yoN7o"};